import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDictionary = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="Dictionary"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.735 5.001a.21.21 0 0 0-.16.05m.16-.05c.935.156 2.072.47 3.133.918.961.407 1.805.904 2.382 1.453v7.922a3 3 0 0 0-.155-.121c-.627-.452-1.642-.902-2.619-1.255-.986-.356-2.036-.648-2.77-.748l-.018-.002a.21.21 0 0 1-.188-.212V5.211a.21.21 0 0 1 .074-.16m-.341-1.483c.233-.068.478-.085.718-.051l.018.003c1.048.174 2.306.52 3.483 1.018 1.166.493 2.322 1.165 3.103 2.025a.75.75 0 0 1 .195.504v9.683a.75.75 0 0 1-.75.75 1.66 1.66 0 0 1-.763-.169 1.7 1.7 0 0 1-.502-.395 5 5 0 0 1-.2-.234c-.102-.124-.169-.206-.317-.312-.45-.325-1.302-.719-2.251-1.061-.936-.338-1.87-.591-2.455-.671A1.71 1.71 0 0 1 2 12.95v-.003l.75.005H2V5.21a1.71 1.71 0 0 1 1.233-1.643Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M16.265 5.001a.21.21 0 0 1 .161.05M16.265 5c-.934.156-2.072.47-3.133.918-.961.407-1.805.904-2.382 1.453v7.922q.075-.063.155-.121c.627-.452 1.642-.902 2.62-1.255.985-.356 2.035-.648 2.769-.748l.018-.002a.21.21 0 0 0 .188-.212V5.211a.21.21 0 0 0-.074-.16m.341-1.483a1.7 1.7 0 0 0-.718-.051l-.018.003c-1.048.174-2.306.52-3.483 1.018-1.166.493-2.322 1.165-3.103 2.025a.75.75 0 0 0-.195.504v9.683c0 .414.336.75.75.75.275 0 .53-.051.763-.169a1.7 1.7 0 0 0 .502-.395c.087-.095.148-.17.2-.234.102-.124.169-.206.317-.312.45-.325 1.302-.719 2.251-1.061.937-.338 1.87-.591 2.455-.671A1.71 1.71 0 0 0 18 12.95v-.003l-.75.005H18V5.21a1.71 1.71 0 0 0-1.233-1.643Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDictionary;
